import faker from 'faker'
import _ from 'lodash'
import moment from 'moment'
import hrms6aeLabels from 'assets/labels/hrms6ae'
import labels from 'src/../config/label.js'

export const mocker = {
  labels () {
    let codreqstDropdown = {}
    let key = ''
    const totalCodreqstDropdown = 5 + Math.floor(Math.random() * 6)
    for (var i = 1; i < totalCodreqstDropdown; i++) {
      key = _.padStart(faker.lorem.word(), 4, '0')
      codreqstDropdown[key] = faker.lorem.word()
    }
    return {
      labels: hrms6aeLabels,
      dropdowns: {
        codreqst: {
          en: codreqstDropdown,
          th: codreqstDropdown
        }
      }
    }
  },
  index () {
    let mockRows = []
    const mockTotal = 100
    for (var i = 1; i <= mockTotal; i++) {
      mockRows.push({
        id: i,
        codempid_query: faker.lorem.word(),
        desc_codempid_query: faker.name.findName(),
        dtereq: moment().daysInMonth() + '/' + _.padStart(moment().month() + 1, 2, '0') + '/' + moment().year(),
        numseq: faker.random.number().toString().substr(0, 1),
        dtework: moment().daysInMonth() + '/' + _.padStart(moment().month() + 1, 2, '0') + '/' + moment().year(),
        codshift: faker.address.stateAbbr(),
        timin: faker.date.past().toString().substr(16, 5) + ' - ' + faker.date.past().toString().substr(16, 5),
        staappr: faker.lorem.word(),
        remarkap: faker.lorem.words(),
        desc_codappr: faker.name.findName(),
        desc_codempap: faker.name.findName()
      })
    }

    return {
      total: mockTotal,
      rows: mockRows
    }
  },
  currentNumseq () {
    return 1
  },
  detail () {
    let mockRows = []
    const mockTotal = 1
    for (var i = 1; i <= mockTotal; i++) {
      mockRows.push({
        id: i,
        dtework: moment().daysInMonth() + '/' + _.padStart(moment().month() + 1, 2, '0') + '/' + moment().year(),
        day: faker.address.stateAbbr(),
        codshift: faker.address.stateAbbr(),
        dtein: moment().daysInMonth() + '/' + _.padStart(moment().month() + 1, 2, '0') + '/' + moment().year(),
        timin: faker.date.past().toString().substr(16, 5),
        dteout: moment().daysInMonth() + '/' + _.padStart(moment().month() + 1, 2, '0') + '/' + moment().year(),
        timout: faker.date.past().toString().substr(16, 5),
        codreqst: faker.random.number().toString().substr(0, 4),
        remark: faker.lorem.word(),
        qtylate: faker.date.past().toString().substr(16, 5),
        qtyearly: faker.date.past().toString().substr(16, 5),
        qtyabsent: faker.date.past().toString().substr(16, 5),
        desc_staappr: faker.lorem.word(),
        codempid_query: faker.random.number()
      })
    }
    let mockPopup = {
      codempid: faker.finance.mask(),
      desc_codempid: faker.name.findName()
    }
    let mockPopupRows = []
    const mockPopupTotal = 1
    for (var a = 1; a <= mockPopupTotal; a++) {
      mockPopupRows.push({
        id: a,
        dtework: moment().daysInMonth() + '/' + _.padStart(moment().month() + 1, 2, '0') + '/' + moment().year(),
        typwork: faker.address.stateAbbr(),
        codshift: faker.address.stateAbbr(),
        timsten: faker.date.past().toString().substr(16, 5) + ' - ' + faker.date.past().toString().substr(16, 5),
        dtein: moment().daysInMonth() + '/' + _.padStart(moment().month() + 1, 2, '0') + '/' + moment().year(),
        timin: faker.date.past().toString().substr(16, 5),
        dteout: moment().daysInMonth() + '/' + _.padStart(moment().month() + 1, 2, '0') + '/' + moment().year(),
        timout: faker.date.past().toString().substr(16, 5),
        atmfile: faker.lorem.word()
      })
    }

    return {
      table: {
        total: mockTotal,
        rows: mockRows
      },
      popup: {
        detail: mockPopup,
        table: {
          total: mockPopupTotal,
          rows: mockPopupRows
        }
      }
    }
  },
  detailSearch () {
    let mockRows = []
    const mockTotal = 1
    for (var i = 1; i <= mockTotal; i++) {
      mockRows.push({
        id: i,
        dtework: moment().daysInMonth() + '/' + _.padStart(moment().month() + 1, 2, '0') + '/' + moment().year(),
        day: faker.address.stateAbbr(),
        codshift: faker.address.stateAbbr(),
        dtein: moment().daysInMonth() + '/' + _.padStart(moment().month() + 1, 2, '0') + '/' + moment().year(),
        timin: faker.date.past().toString().substr(16, 5),
        dteout: moment().daysInMonth() + '/' + _.padStart(moment().month() + 1, 2, '0') + '/' + moment().year(),
        timout: faker.date.past().toString().substr(16, 5),
        codreqst: faker.random.number().toString().substr(0, 4),
        remark: faker.lorem.word(),
        qtylate: faker.date.past().toString().substr(16, 5),
        qtyearly: faker.date.past().toString().substr(16, 5),
        qtyabsent: faker.date.past().toString().substr(16, 5),
        desc_staappr: faker.lorem.word(),
        codempid_query: faker.random.number()
      })
    }
    let mockPopup = {
      codempid: faker.finance.mask(),
      desc_codempid: faker.name.findName()
    }
    let mockPopupRows = []
    const mockPopupTotal = 1 + Math.floor(Math.random() * 10)
    for (var a = 1; a <= mockPopupTotal; a++) {
      mockPopupRows.push({
        id: a,
        dtework: moment().daysInMonth() + '/' + _.padStart(moment().month() + 1, 2, '0') + '/' + moment().year(),
        typwork: faker.address.stateAbbr(),
        codshift: faker.address.stateAbbr(),
        timsten: faker.date.past().toString().substr(16, 5) + ' - ' + faker.date.past().toString().substr(16, 5),
        dtein: moment().daysInMonth() + '/' + _.padStart(moment().month() + 1, 2, '0') + '/' + moment().year(),
        timin: faker.date.past().toString().substr(16, 5),
        dteout: moment().daysInMonth() + '/' + _.padStart(moment().month() + 1, 2, '0') + '/' + moment().year(),
        timout: faker.date.past().toString().substr(16, 5),
        atmfile: faker.lorem.word()
      })
    }

    return {
      table: {
        total: mockTotal,
        rows: mockRows
      },
      popup: {
        detail: mockPopup,
        table: {
          total: mockPopupTotal,
          rows: mockPopupRows
        }
      }
    }
  },
  save () {
    return labels.mockPostMessage
  },
  cancel () {
    return labels.mockPostMessage
  }
}



// WEBPACK FOOTER //
// ./src/api/hrms6ae/mocker.js